<template>
  <v-row>
    <v-col>
      <v-select
        v-if="!user.roles.includes('CONSULTATION_PIECE') && DRHs"
        :items="DRHs"
        :label="user.displayName"
        item-text="nomPrenomGestionnaire"
        v-model="DRH"
        @change="changerDRH"
        item-value="uidGestionnaire"
        single-line
        clearable
      ></v-select>
      <v-progress-circular
        v-else-if="!user.roles.includes('CONSULTATION_PIECE')"
        indeterminate
        color="primary"
      ></v-progress-circular>
    </v-col>
    <v-col cols="12" md="12">
      <v-data-table
        :headers="headers"
        :items="filteredDemandes"
        class="elevation-1"
        pagination.sync="pagination"
        :loading="loading"
        loading-text="Chargement..."
        search
      >
        <template v-slot:[`header.nomPrenom`]="{ header }">
          {{ header.text }}
          <v-menu offset-y :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon slot="activator" v-bind="attrs" v-on="on">
                <v-icon small :color="filterNomPrenom ? 'info' : ''"
                  >mdi-filter</v-icon
                >
              </v-btn>
            </template>
            <v-card class="block">
              <v-text-field
                v-model="filterNomPrenom"
                label="entrer un élément de recherche"
              >
              </v-text-field>
              <v-btn color="error" small text @click="filterNomPrenom = null"
                >Annuler
              </v-btn>
            </v-card>
          </v-menu>
        </template>
        <template v-slot:[`header.validation`]="{ header }">
          {{ header.text }}
          <v-menu offset-y click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon slot="activator" v-bind="attrs" v-on="on"
                ><v-icon small :color="filterValide ? 'info' : ''"
                  >mdi-filter</v-icon
                ></v-btn
              >
            </template>
            <v-list>
              <v-checkbox
                dense
                label="en cours"
                v-model="filterValide"
                :value="null"
              ></v-checkbox>
              <v-checkbox
                dense
                label="accepté"
                v-model="filterValide"
                :value="true"
              ></v-checkbox>
              <v-checkbox
                dense
                label="refusé"
                v-model="filterValide"
                :value="false"
              ></v-checkbox>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:[`header.type`]="{ header }">
          {{ header.text }}
          <v-menu offset-y click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon slot="activator" v-bind="attrs" v-on="on"
                ><v-icon small :color="filterType ? 'info' : ''"
                  >mdi-filter</v-icon
                ></v-btn
              >
            </template>
            <v-list>
              <v-checkbox
                dense
                label="Adresse"
                v-model="filterType"
                value="adresse"
              ></v-checkbox>
              <v-checkbox
                dense
                label="Etat Civil"
                v-model="filterType"
                value="etatcivil"
              ></v-checkbox>
              <v-checkbox
                dense
                label="Situation Familiale"
                v-model="filterType"
                value="SituationFamiliale"
              ></v-checkbox>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:[`item.nameFile`]="{ item }">
          <v-btn
            v-if="item.type != 'adresse' && item.type != 'telephone'"
            icon
            @click="afficherPDF(item)"
            ><v-icon color="green">mdi-book-open-variant</v-icon></v-btn
          >
        </template>
        <template v-slot:[`item.createAt`]="{ item }">
          <v-col>{{
            item.createAt
              ? new Date(item.createAt).toLocaleString("fr-FR", {
                  weekday: "long",
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })
              : ""
          }}</v-col>
        </template>
        <template v-slot:[`item.libelle`]="{ item }">
          <v-col v-if="item.type != 'adresse'">{{ item.libelle }}</v-col>
          <v-col v-else>{{ item.contenu }}</v-col>
        </template>
        <template v-slot:[`item.validation`]="{ item }">
          <div v-if="!user.roles.includes('CONSULTATION_PIECE')">
            <v-col v-if="item.validation == null" color="warning">
              <v-btn
                color="warning"
                @click="openValidation(item)"
                rounded
                outlined
                small
                >A valider &nbsp;<v-icon small
                  >mdi-checkbox-marked-circle-outline</v-icon
                ></v-btn
              >
            </v-col>
            <v-chip v-else-if="item.validation == 0" color="error"
              >refusé</v-chip
            >
            <v-chip v-else-if="item.validation == 1" color="success"
              >accepté</v-chip
            >
          </div>
          <div v-else>
            <v-chip v-if="item.validation == null" color="warning">
              A valider
            </v-chip>
            <v-chip v-else-if="item.validation == 0" color="error"
              >refusé</v-chip
            >
            <v-chip v-else-if="item.validation == 1" color="success"
              >accepté</v-chip
            >
          </div>
        </template>
        <template v-slot:[`item.messagerie`]="{ item }">
          <div v-if="!user.roles.includes('CONSULTATION_PIECE')">
            <v-col>
              <v-badge
                :color="
                  item.nombreMessagesGestionnaire <= 0
                    ? 'transparent'
                    : 'primary'
                "
                :content="item.nombreMessagesGestionnaire"
              >
                <v-btn
                  icon
                  @click="lancerMessagerie(item)"
                  :color="item.nombreMessagesGestionnaire > 0 ? 'red' : 'grey'"
                  ><v-icon>chat</v-icon></v-btn
                >
              </v-badge>
            </v-col>
          </div>
          <div v-else>
            <v-icon red>close</v-icon>
          </div>
        </template>
        <template v-slot:[`item.messageRefus`]="{ item }">
          <v-tooltip
            bottom
            color="red"
            max-width="150px"
            v-if="item.messageRefus"
          >
            <template v-slot:activator="{ on, attrs }">
              <span v-on="on" v-bind="attrs">{{ item.messageRefusPetit }}</span>
            </template>
            <span>{{ item.messageRefus }}</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-col>
    <v-dialog
      v-model="popUpValidation"
      persistent
      :overlay="false"
      max-width="1500px"
      transition="dialog-transition"
    >
      <BaseBlock title="Validation de la demande">
        <v-row align="center" justify="center" v-if="demande">
          <v-col :cols="demande.type != 'adresse' ? '3' : ''">
            Type
            <v-text-field :value="demande.type" readonly></v-text-field><br />
            Libellé de la demande
            <v-text-field :value="demande.libelle" readonly></v-text-field
            ><br />
            <p v-if="demande.type == 'adresse'">Adresse Postale</p>
            <v-textarea
              v-if="demande.type == 'adresse'"
              :value="demande.contenu"
              readonly
            ></v-textarea>
          </v-col>
          <v-col>
            <!-- <v-col v-if="demande.type != 'adresse'"> -->
            <v-card
              v-if="demande.type != 'adresse'"
              class="d-flex flex-column"
              height="70vh"
            >
              <v-card-actions class="justify-center grey lighten-4 py-1">
                <v-btn
                  @click="documentLeft"
                  icon
                  :disabled="temoin == 0"
                  color="success"
                >
                  <v-icon>chevron_left</v-icon>
                </v-btn>

                <span class="caption mx-2"
                  >Document {{ temoin + 1 }} / {{ nombreDocuments }}</span
                >

                <v-btn
                  @click="documentRight"
                  icon
                  :disabled="temoin >= nombreDocuments - 1"
                  color="success"
                >
                  <v-icon>chevron_right</v-icon>
                </v-btn>
              </v-card-actions>

              <v-card-text
                class="flex-grow-1 p-0"
                style="padding: 0; overflow: hidden"
              >
                <iframe
                  :src="iframeSrc"
                  width="100%"
                  height="100%"
                  frameborder="0"
                  style="display: block; background: white"
                ></iframe>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row align="center" justify="center"
          ><div clas="text-center" v-if="!finForm">
            <v-col align-self="end">
              <v-btn color="success" @click="validationForm(1)">Accepter</v-btn
              >&nbsp;
              <v-btn color="error" @click="dialogRefus = true">Refuser</v-btn>
              &nbsp;
              <v-btn @click="fermerDialogValidation" color="info"
                ><v-icon>mdi-close</v-icon>Fermer</v-btn
              >
            </v-col>
          </div>
          <div v-else>
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular></div
        ></v-row>
      </BaseBlock>
    </v-dialog>
    <v-dialog v-model="dialogRefus" persistent>
      <BaseBlock>
        <v-form v-model="validRefus" ref="formRefus" lazy-validation>
          <v-textarea
            v-model="depotPiece.messageRefus"
            name="Expliquer le refus de la demande"
            label="Expliquez le refus de la demande"
            :rules="[
              (value) => !!value || 'Champ requis.',
              (v) =>
                (v || '').length <= 4000 ||
                `le nombre de caractères doit être inférieur à 4000.`,
            ]"
            required
            auto-grow
            counter="4000"
          ></v-textarea>
          <v-row align="center" justify="center"
            ><div clas="text-center">
              <v-col align-self="end">
                <v-btn
                  color="success"
                  @click="confirmerDialogRefus"
                  :disabled="!validRefus"
                  >Valider</v-btn
                >
                <v-btn color="error" @click="annulerRefus">annuler</v-btn>
              </v-col>
            </div></v-row
          >
        </v-form>
      </BaseBlock>
    </v-dialog>
    <v-col cols="12">
      <BaseBlock title="Information" v-if="DRHMessageInformationDepotPiece">
        <div v-html="DRHMessageInformationDepotPiece"></div>
      </BaseBlock>
    </v-col>
    <messagerie
      v-if="!user.roles.includes('CONSULTATION_PIECE')"
      ref="messagerie"
      :temoinGestionnaire="true"
    ></messagerie>

    <v-dialog
      v-model="dialogPDF"
      persistent
      width="70%"
      height="70%"
      transition="dialog-bottom-transition"
    >
      <v-card class="d-flex flex-column" height="70vh">
        <v-card-actions class="justify-center grey lighten-4 py-1">
          <v-btn
            @click="documentLeft"
            icon
            :disabled="temoin == 0"
            color="success"
          >
            <v-icon>chevron_left</v-icon>
          </v-btn>

          <span class="caption mx-2"
            >Document {{ temoin + 1 }} / {{ nombreDocuments }}</span
          >

          <v-btn
            @click="documentRight"
            icon
            :disabled="temoin >= nombreDocuments - 1"
            color="success"
          >
            <v-icon>chevron_right</v-icon>
          </v-btn>
        </v-card-actions>

        <v-card-text
          class="flex-grow-1 p-0"
          style="padding: 0; overflow: hidden"
        >
          <iframe
            v-if="dialogPDF"
            :src="iframeSrc"
            width="100%"
            height="100%"
            frameborder="0"
            style="display: block; background: white"
          ></iframe>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="justify-center">
          <v-btn
            color="error"
            cctext
            @click="
              dialogPDF = false;
              iframeSrc = null;
              nombreDocuments = -1;
              temoin = 0;
              document = null;
            "
          >
            Fermer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";
import ApiDepotPieceRepository from "@/repositories/ApiDepotPieceRepository";
import ApiGestionnaireRepository from "@/repositories/ApiGestionnaireRepository";
import ApiRefMessageRepository from "@/repositories/ApiRefMessageRepository";
import { mapState } from "vuex";
import messagerie from "@/components/Messagerie";

export default {
  name: "DRHDepotPiece",
  components: { BaseBlock, messagerie },
  data() {
    return {
      headers: [
        {
          text: "Numéro",
          value: "id",
        },
        {
          text: "Demandeur",
          value: "nomPrenom",
          align: "start",
        },
        {
          text: "Date de création",
          value: "createAt",
        },
        {
          text: "Type",
          value: "type",
        },
        {
          text: "Statut",
          value: "validation",
        },
        { text: "Fichier(s) joint(s)", value: "nameFile" },
        {
          text: "Libelle",
          value: "libelle",
        },
        {
          text: "Messagerie",
          value: "messagerie",
        },
        {
          text: "Message de refus",
          value: "messageRefus",
        },
      ],
      demande: null,
      demandes: [],
      filterValide: [null],
      filterType: ["SituationFamiliale", "etatcivil", "adresse"],
      filterNomPrenom: null,
      depotPiece: {
        nameFile: null,
        validation: null,
        nomPrenom: null,
        noSIRH: null,
        messageRefus: null,
      },
      depotPieceSave: {
        nameFile: null,
        validation: null,
        nomPrenom: null,
        noSIRH: null,
        messageRefus: null,
      },
      valid: true,
      validRefus: true,
      dialog: false,
      dialogPDF: false,
      editedIndex: -1,
      message: null,
      hasResultats: false,
      loading: false,
      DRHs: null,
      DRH: null,
      popUpValidation: false,
      disabledForm: true,
      dialogRefus: false,
      iframeSrc: "",
      finForm: false,
      affichagePDF: true,
      temoin: 0,
      nombreDocuments: -1,
      DRHMessageInformationDepotPiece: null,
      dialogMessagerie: false,
      demandeMessagerie: null,
      consultationPiece: false,
    };
  },
  computed: {
    filteredDemandes() {
      var conditions = [];
      conditions.push(this.filterValidation);
      if (this.filterNomPrenom) {
        conditions.push(this.filtrageNomPrenom);
      }
      conditions.push(this.filtrageType);
      if (conditions.length > 0) {
        return this.demandes.filter((demande) => {
          return conditions.every((condition) => {
            return condition(demande);
          });
        });
      }
      return this.demandes;
    },

    file() {
      return this.depotPiece.nameFile != null
        ? new File([], this.depotPiece.nameFile)
        : new File([], null);
    },
    ...mapState(["user", "isAdmin"]),
  },
  async created() {
    if (this.$route.path == "/consultationSituationFamiliale") {
      this.consultationPiece = true;
    }
    if (sessionStorage.depotPiece) {
      this.depotPiece = JSON.parse(sessionStorage.depotPiece);
    }
    this.loading = true;
    if (this.user.roles.includes("CONSULTATION_PIECE")) {
      //console.log("yeeah");
      this.demandes =
        await ApiDepotPieceRepository.getDemandesGestionnairesPIECE();
      this.filterValide = [null, true, false];
    } else {
      this.demandes = await ApiDepotPieceRepository.getDemandesGestionnaire();
      this.DRHs = await ApiGestionnaireRepository.getGestionnaires();
      this.DRHMessageInformationDepotPiece =
        await ApiRefMessageRepository.getDRHMessageInformationDepotPiece();
    }
    this.loading = false;
  },
  watch: {
    demandes: function () {
      this.demandes.forEach((demande) => {
        if (demande.messageRefus != null) {
          demande.messageRefusPetit = demande.messageRefus.substr(0, 20);
          return demande.messageRefusPetit + demande.messageRefus.length > 20
            ? "..."
            : "";
        }
        return null;
      });
    },
  },
  methods: {
    async validerDepotPiece() {
      if (this.$refs.form.validate()) {
        await ApiDepotPieceRepository.updateDemande(this.depotPiece);
        this.demandes[this.editedIndex] = Object.assign({}, this.depotPiece);

        this.filterValide = [null];

        this.disabledForm = true;
      }
    },
    annuler() {
      Object.assign(this.depotPiece, this.depotPieceSave);
      this.disabledForm = true;
    },
    formOn() {
      this.dialog = true;
    },
    validationForm(valider) {
      if (this.disabledForm) {
        this.$confirm(
          "<b>Confirmez vous votre choix de " +
            (valider == "0" ? "refuser" : "valider") +
            " la demande ?</b>"
        ).then(async (reponse) => {
          if (reponse) {
            this.finForm = true;
            this.$toast.info("Vous avez confirmé.");
            if (valider == 1) {
              this.depotPiece.validation = 1;
            } else this.depotPiece.validation = 0;
            this.loading = true;
            this.$toast.info("envoi du mail en cours...");

            let updateDemande = await ApiDepotPieceRepository.updateDemande(
              this.depotPiece
            );
            this.finForm = false;
            this.loading = false;
            Object.assign(this.demandes[this.editedIndex], updateDemande);
            this.editedIndex = -1;
            this.depotPiece = Object.assign({});
            this.$toast.info("Demande mise à jour.");
            this.popUpValidation = false;
            this.iframeSrc = "";
            this.temoin = 0;
            this.demande = null;
          } else {
            this.$toast.info("Vous n'avez pas confirmé.");
          }
          if (this.$refs.formRefus) {
            this.$refs.formRefus.reset();
          }
          this.affichagePDF = true;
        });
      } else {
        this.$toast.warn("Veuillez valider le formulaire.");
      }
    },
    filterValidation(item) {
      return this.filterValide.includes(item.validation);
    },
    async changerDRH() {
      if (this.DRH != null) {
        this.loading = true;
        this.demandes = [];
        this.demandes =
          await ApiDepotPieceRepository.getDemandesGestionnaireByUid(this.DRH);
        this.loading = false;
      } else {
        this.demandes = await ApiDepotPieceRepository.getDemandesGestionnaire();
      }
    },

    async openValidation(item) {
      this.nombreDocuments = item.nombreDocuments;
      this.editedIndex = this.demandes.indexOf(item);
      this.depotPiece = Object.assign({}, item);
      this.demande = item;
      this.iframeSrc = await ApiDepotPieceRepository.getDemandeFileDRH(
        item.id,
        this.temoin
      );
      this.popUpValidation = true;
    },

    modifierValidation() {
      Object.assign(this.depotPieceSave, this.depotPiece);
      this.disabledForm = false;
    },

    fermerDialogValidation() {
      if (!this.disabledForm) {
        this.$toast.warn("Veuillez valider le formulaire.");
      } else {
        this.temoin = 0;
        this.nombreDocuments = -1;
        this.iframeSrc = "";
        this.popUpValidation = false;
        this.demande = null;
        if (this.$refs.formRefus) {
          this.$refs.formRefus.reset();
        }
        this.affichagePDF = true;
      }
    },

    confirmerDialogRefus() {
      if (this.$refs.formRefus.validate()) {
        this.dialogRefus = false;
        this.validationForm(0);
      }
    },
    annulerRefus() {
      this.depotPiece.messageRefus = null;
      this.$refs.formRefus.reset();
      this.dialogRefus = false;
    },
    filtrageNomPrenom(item) {
      return item.nomPrenom
        .toLowerCase()
        .includes(this.filterNomPrenom.toLowerCase());
    },
    filtrageType(item) {
      return this.filterType.includes(item.type);
    },
    async afficherPDF(item) {
      this.demande = item;
      this.nombreDocuments = item.nombreDocuments;
      this.iframeSrc = await ApiDepotPieceRepository.getDemandeFileDRH(
        item.id,
        this.temoin
      );

      this.dialogPDF = true;
    },

    async documentRight() {
      this.temoin += 1;
      this.iframeSrc = await ApiDepotPieceRepository.getDemandeFileDRH(
        this.demande.id,
        this.temoin
      );
    },

    async documentLeft() {
      this.temoin -= 1;
      this.iframeSrc = await ApiDepotPieceRepository.getDemandeFileDRH(
        this.demande.id,
        this.temoin
      );
    },
    lancerMessagerie(item) {
      this.$refs.messagerie.openMessagerie(item);
      item.nombreMessagesUtilisateur = 0;
    },
  },
};
</script>
